export const INTEGRATED_PRIVACY_POLICY_URL =
  'https://privacy.megazone.com/production/mzc/privacy/index.html';

export const CCTV_OPERATION_POLICY_URL =
  'https://privacy.megazone.com/production/mzc/cctv/index.html';

export const TERMS_OF_SERVICE_URL = 'https://cloudplex.megazone.com/terms/latest';

export const PRIVACY_NOTICE_COOKIE = 'cp_privacy_notice_until';

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

/** 2026-10-01 00:00:00 KST through 2026-10-08 23:59:59 KST. */
export const PRIVACY_NOTICE_START = Date.parse('2026-10-01T00:00:00+09:00');
export const PRIVACY_NOTICE_END = Date.parse('2026-10-09T00:00:00+09:00');

export const isWithinPrivacyNoticePeriod = (now: number) =>
  now >= PRIVACY_NOTICE_START && now < PRIVACY_NOTICE_END;

export const nextKstMidnight = (now: number) => {
  const kst = now + KST_OFFSET_MS;
  return (Math.floor(kst / DAY_MS) + 1) * DAY_MS - KST_OFFSET_MS;
};

export const resolveCookieDomain = (hostname: string) => {
  if (hostname === 'localhost' || hostname.endsWith('.localhost')) return undefined;
  if (hostname === 'cloudplex.so' || hostname.endsWith('.cloudplex.so')) return 'cloudplex.so';
  return undefined;
};

export const readNoticeHiddenUntil = (cookie: string) => {
  const entry = cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${PRIVACY_NOTICE_COOKIE}=`));
  if (entry == null) return null;
  const value = Number(decodeURIComponent(entry.slice(PRIVACY_NOTICE_COOKIE.length + 1)));
  return Number.isFinite(value) ? value : null;
};

export const shouldShowPrivacyNotice = (now: number, cookie: string) => {
  if (!isWithinPrivacyNoticePeriod(now)) return false;
  const hiddenUntil = readNoticeHiddenUntil(cookie);
  return hiddenUntil == null || hiddenUntil <= now;
};

export const buildPrivacyNoticeDismissCookie = (now: number, hostname: string, secure: boolean) => {
  const until = nextKstMidnight(now);
  const domain = resolveCookieDomain(hostname);
  const parts = [
    `${PRIVACY_NOTICE_COOKIE}=${until}`,
    `expires=${new Date(until).toUTCString()}`,
    'path=/',
    'SameSite=Lax'
  ];
  if (domain != null) parts.push(`domain=${domain}`);
  if (secure) parts.push('Secure');
  return parts.join('; ');
};

export const dismissPrivacyNoticeForToday = () => {
  document.cookie = buildPrivacyNoticeDismissCookie(
    Date.now(),
    window.location.hostname,
    window.location.protocol === 'https:'
  );
};
